function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 80,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 133.025V52C20 45.3726 25.3726 40 32 40H128C134.627 40 140 45.3726 140 52V128.087C125.738 147.489 103.286 160 78.0328 160C54.9923 160 34.2841 149.586 20 133.025Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.0617 58.6667C64.0617 57.1939 62.9046 56 61.4771 56C60.0497 56 58.8925 57.1939 58.8925 58.6667L58.8923 68.4444H54.5846C53.8991 68.4444 53.2417 68.7254 52.757 69.2255C52.2723 69.7256 52 70.4039 52 71.1111V75.5556C52.0037 79.3339 53.3033 82.989 55.6686 85.8735C58.0339 88.758 61.3122 90.6858 64.9231 91.3156V96.4444C64.9231 100.57 66.5116 104.527 69.3391 107.444C72.1665 110.361 76.0014 112 80.0001 112C83.9988 112 87.8336 110.361 90.6611 107.444C93.4886 104.527 95.0771 100.57 95.0771 96.4444V71.1111C95.0771 69.2251 95.8032 67.4164 97.0958 66.0828C98.3883 64.7492 100.141 64 101.969 64H105.415C106.843 63.9999 108 62.806 108 61.3333C108 59.8606 106.843 58.6668 105.416 58.6667H101.969C98.7705 58.6667 95.7026 59.9778 93.4406 62.3116C91.1786 64.6453 89.9078 67.8106 89.9078 71.1111V96.4444C89.9078 99.1555 88.864 101.756 87.0059 103.673C85.1479 105.59 82.6278 106.667 80.0001 106.667C77.3724 106.667 74.8523 105.59 72.9943 103.673C71.1362 101.756 70.0924 99.1555 70.0924 96.4444V91.3156C73.7032 90.6858 76.9816 88.758 79.3469 85.8735C81.7122 82.989 83.0118 79.3339 83.0155 75.5556V71.1111C83.0155 70.4039 82.7432 69.7256 82.2585 69.2255C81.7738 68.7254 81.1163 68.4444 80.4309 68.4444H76.1232V58.6667C76.1232 57.1939 74.9658 56 73.5384 56C72.1109 56 70.9538 57.1939 70.9538 58.6667C70.9538 58.6762 70.9538 58.6856 70.9539 58.6951V68.4444H64.0616L64.0617 58.6667ZM57.1692 73.7778V75.5556C57.1692 78.3845 58.2585 81.0976 60.1973 83.098C62.1362 85.0984 64.7658 86.2222 67.5077 86.2222C70.2497 86.2222 72.8793 85.0984 74.8182 83.098C76.757 81.0976 77.8462 78.3845 77.8462 75.5556V73.7778H57.1692Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 80,
  y1: 0,
  x2: 80,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CBD7EB",
  stopOpacity: 0
})));

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.75a1f364.svg";
export { ForwardRef as ReactComponent };